import React from 'react';
import { Card } from './ui/card';

const ExperienceCard = ({ experience }) => {
  return (
    <Card className="relative h-96 overflow-hidden border-none shadow-xl hover:shadow-2xl transition-all duration-300 group cursor-pointer">
      <div className="absolute inset-0">
        <img 
          src={experience.image} 
          alt={experience.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/20 group-hover:from-[#1e3a8a]/90 transition-all duration-300" />
      </div>
      <div className="relative h-full flex flex-col justify-end p-8 text-white">
        <h3 className="text-3xl font-bold mb-3 group-hover:text-[#d97706] transition-colors duration-300">
          {experience.title}
        </h3>
        <p className="text-gray-200 leading-relaxed text-lg">
          {experience.description}
        </p>
      </div>
    </Card>
  );
};

export default ExperienceCard;
